var CommunityTitle = React.createClass({
  propTypes: {
    community: React.PropTypes.object.isRequired,
    className: React.PropTypes.string
  },
  getDefaultProps() {
    return {
      className: "",
    };
  },
  render() {
    let comm = this.props.community;
    let imgPath = Config.contextPath + (RA.Utils.isNotBlank(comm.image) ? comm.image : "/app/images/default-community.png");

    return (
      <div className={"comm-title " + this.props.className}>
        <div className="comm-title__image-wrap -center">
          <img src={imgPath} className="comm-title__image" alt={comm.name} />
        </div>
        <div className="comm-title__content">
          <h2 className="comm-title__name">{comm.name}</h2>
          {this.props.children}
        </div>
      </div>
    )
  }
})